import { render } from "./BodyLoading.vue?vue&type=template&id=76d27bb6&scoped=true"
import script from "./BodyLoading.vue?vue&type=script&lang=js"
export * from "./BodyLoading.vue?vue&type=script&lang=js"

import "./BodyLoading.vue?vue&type=style&index=0&id=76d27bb6&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-76d27bb6"]])

export default __exports__